/*eslint-disable import/default, import/namespace, import/no-named-as-default, import/no-named-as-default-member */
import React from 'react';
import ReactMarkdown from 'react-markdown';
import suggestions from '../../data/suggestions.json';
import {testAnswers, testStats, testSuggestion} from '../../utils/checks'

const Suggestions = (props) => {
  function testSuggestion(suggestion) {
    return testAnswers(props, suggestion.criteria) || testStats(props, suggestion.criteria);
  }

  function sentenceFor(suggestion, index) {
    return <li key={index} className="results__list__item"><ReactMarkdown source={suggestion.text} /></li>;
  }

  const sentences = suggestions.filter(testSuggestion).map(sentenceFor);

  if (sentences.length === 0) {
    return null;
  }

  return (
    <div className="results__list">
      <div className="results__list__title">How can I fix it?</div>
      <ul>
        {sentences}
      </ul>
    </div>
  );
};

Suggestions.propTypes = {
  answers: React.PropTypes.object,
  stats: React.PropTypes.object
};

export default Suggestions;



// WEBPACK FOOTER //
// ./src/components/results/Suggestions.js